import chefs from './chefs';
export default {
    chefs: chefs,
};
